import { httpGet, httpPost, httpPut, httpDelete, httpPatch } from '@/services/http';

export interface EmailConfig {
  id: string;
  smtp_host: string;
  smtp_port: number;
  smtp_user: string;
  smtp_pass: string;
  from_email: string;
  from_name: string;
  to_email: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface EmailConfigInput {
  smtp_host: string;
  smtp_port: number;
  smtp_user: string;
  smtp_pass: string;
  from_email: string;
  from_name: string;
  to_email: string;
  is_active: boolean;
}

export async function getEmailConfigs(): Promise<EmailConfig[]> {
  return httpGet<EmailConfig[]>('/admin/email-config');
}

export async function getActiveEmailConfig(): Promise<EmailConfig | null> {
  try {
    return await httpGet<EmailConfig>('/admin/email-config/active');
  } catch {
    return null;
  }
}

export async function createEmailConfig(config: EmailConfigInput): Promise<EmailConfig> {
  return httpPost<EmailConfig>('/admin/email-config', config);
}

export async function updateEmailConfig(id: string, config: Partial<EmailConfigInput>): Promise<EmailConfig> {
  return httpPut<EmailConfig>(`/admin/email-config/${id}`, config);
}

export async function deleteEmailConfig(id: string): Promise<void> {
  return httpDelete(`/admin/email-config/${id}`);
}

export async function setActiveEmailConfig(id: string): Promise<void> {
  return httpPatch<void>(`/admin/email-config/${id}/set-active`);
}
